import type { ClampingTool2Dto, StoreClampingToolResponseDto } from '@api/generated/models';
import type { ClampingTool, StoreClampingToolResponse } from '@api/domain/types';

export const toClampingTool = (dto: ClampingTool2Dto): ClampingTool => dto;
export const toClampingTools = (dtos: ClampingTool2Dto[]): ClampingTool[] => dtos.map(toClampingTool);
export const toStoreClampingToolResponse = (dto: StoreClampingToolResponseDto): StoreClampingToolResponse => dto;
